// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"lq-z","imageAndVideoCount":"mq-z","imageAndVideoContainer":"nq-z","viewAllReviews":"oq-z"};